import React, { useMemo } from "react";
import { isNumber } from "lodash";

import ExecutorReport from "../../../../../../../../../../services/ExecutorReport";
import Language from "../../../../../../../../../../services/Language";
import formatNumber from "../../../../../../../../../../utils/formatNumber";
import { CellContentRoot } from "../../../../../../../../../../components/LightTable";

export const cellProcessing = (
	item: AdditionalFeeCellContent.Props["item"],
) => {
	if (!isNumber(item?.executorRate?.additional)) return "";
	return formatNumber(item?.executorRate?.additional);
};

const AdditionalFeeCellContent: React.FC<AdditionalFeeCellContent.Props> = ({
	item,
}) => {
	const content = useMemo(() => cellProcessing(item), [item]);

	return (
		<CellContentRoot alignItems="center" w="100%" h="100%">
			{content}
		</CellContentRoot>
	);
};

declare namespace AdditionalFeeCellContent {
	interface Props {
		item: ExecutorReport.Model;
		language: Language;
	}
}

export default AdditionalFeeCellContent;
